<div [formGroup]="form">
  <kendo-dropdownlist [formControlName]="field.uniquename"
                      [ngClass]="{'input-validation-error': isTouched && isInValid }"
                      [data]="filteredData"
                      [defaultItem]="defaultItem"
                      [valuePrimitive]="true"
                      min=1,
                      textField="Answer"
                      valueField="FormAnswerID"
                      [filterable]="true"
                      (filterChange)="filterData($event)">
    <ng-template kendoDropDownListItemTemplate let-dataItem>
      <span [innerHTML]="dataItem.Answer"></span>
    </ng-template>
  </kendo-dropdownlist>


</div>
<style>
  .mat-select, .k-dropdownlist {
    max-width: 350px;
  }
</style>
